export const ORDER_STATUS = {
  ALL: 999,
  PRE_COMMITED: 0,
  OPENED: 1,
  IN_PROGRESS: 2,
  DELIVERY: 3,
  READY: 4,
  FINISHED: 5,
  CANCELLATION_REQUEST: 6,
  CANCELLED: 7,
} as const;

export const REFUND_STATUS = {
  NEW: 0,
  IN_PROGRESS: 1,
  APPROVED: 2,
  REJECTED: 3,
} as const;

export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];
export type RefundStatus = (typeof REFUND_STATUS)[keyof typeof REFUND_STATUS];

// Интерфейс для текстов и цветовых схем
interface StatusProps {
  text: string;
  colorScheme: string;
}

// Маппинг статусов заказов с текстами и цветами
export const orderStatusMap: Record<OrderStatus, StatusProps> = {
  [ORDER_STATUS.ALL]: { text: 'Все', colorScheme: "transparent" },
  [ORDER_STATUS.PRE_COMMITED]: { text: 'Не подтвержден', colorScheme: 'gray' },
  [ORDER_STATUS.OPENED]: { text: 'Открыт', colorScheme: 'green' },
  [ORDER_STATUS.IN_PROGRESS]: { text: 'В работе', colorScheme: 'orange' },
  [ORDER_STATUS.DELIVERY]: { text: 'Доставка', colorScheme: 'blue' },
  [ORDER_STATUS.READY]: { text: 'Готов к выдаче', colorScheme: 'cyan' },
  [ORDER_STATUS.FINISHED]: { text: 'Завершен', colorScheme: 'green' },
  [ORDER_STATUS.CANCELLATION_REQUEST]: { text: 'Запрос на отмену', colorScheme: 'yellow' },
  [ORDER_STATUS.CANCELLED]: { text: 'Отменен', colorScheme: 'red' },
};

// Маппинг статусов возвратов с текстами и цветами
export const refundStatusMap: Record<RefundStatus, StatusProps> = {
  [REFUND_STATUS.NEW]: { text: 'Новый', colorScheme: 'blue' },
  [REFUND_STATUS.IN_PROGRESS]: { text: 'В обработке', colorScheme: 'orange' },
  [REFUND_STATUS.APPROVED]: { text: 'Подтвержден', colorScheme: 'green' },
  [REFUND_STATUS.REJECTED]: { text: 'Отклонен', colorScheme: 'red' },
};

// Значение по умолчанию для неизвестного статуса
export const defaultStatus: StatusProps = {
  text: 'Неизвестный статус',
  colorScheme: 'gray',
};
